<template>
  <div class="dimed wrap">
    <div class="layer layer--sm">
      <div class="layer__body" style="min-height: 2vh">
        <div class="ft--xlg ft--bold">{{ $t('Modal.Payment.msg8') }}</div>
      </div>
      <div class="layer__body" style="min-height: 2vh">
        <div class="ft--xlg ft--bold">{{ text }}</div>
      </div>
      <div class="layer__button" v-if="failYn">
        <button class="btn btn--submit btn--xlg" @mouseup="retry()">{{ $t('User.WineFinish.msg98') }}</button>
      </div>
      <div class="layer__button" v-if="nextYn">
        <button class="btn btn--submit btn--xlg" @mouseup="retry()">{{ $t('User.OrderCheck.msg20') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  name: 'inCompletePosTran',
  data() {
    return {
      instance: axios.create({timeout: 30000}),
      text: this.tranText,
      failYn: this.tranFailYn,
      nextYn: true,
    };
  },
  mounted() {},
  props: {
    tranText: String,
    tranFailYn: Boolean,
  },
  methods: {
    retry() {
      this.posTransactionCall();
    },
    posTransactionCall() {
      this.instance
        .post('/api/pos/processincompletedtransaction', null)
        .then((response) => {
          if (response.data.status == 0) {
            this.$logInfo(`processincompletedtransaction Success`);
            this.failYn = false;
            if (response.data.data.retry) {
              this.text = response.data.message;
              this.failYn = false;
              this.nextYn = true;
            } else {
              this.$emit('closePosTran');
            }
          } else {
            this.text = response.data.message;
            this.failYn = true;
            this.nextYn = false;
            this.$logInfo(`processincompletedtransaction Error : ${response.data.message}`);
          }
        })
        .catch((error) => {
          this.text = error;
          this.failYn = true;
          this.nextYn = false;
          this.$logInfo(`processincompletedtransaction axios Error : ${error}`);
        });
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style scoped>
.dimed {
  z-index: 35;
}
</style>
